import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import { logout } from "../../../actions/admin_action"
import { hist } from "../../..";

export class LogoutImpl extends Component {
  logout = () => {
    localStorage.removeItem("adminData");
    hist.push("/admin/pages/login-page");
  };

  render() {
    const { show, onHide } = this.props;
    // return (
    //   <Modal
    //       show= {show}
    //       onHide= {onHide}
    //       className="common-modal"
    //     >
    //     <Modal.Body>
    //       <div className="common-modal-content">
    //         <span>Are you sure you want to log out of the application?</span>
    //         <div className="common-modal-button remove_project">
    //           <button className="main-btn cancel" onClick= {onHide}>CANCEL</button>
    //           <button className="main-btn" onClick= {()=> {
    //             this.logout();
    //           }}>OK</button>
    //         </div>
    //       </div>
    //     </Modal.Body>
    //   </Modal>
    // )
    return (
      <Dialog
        open={show}
        onClose={onHide}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to log out of the application?"}
        </DialogTitle>
        <DialogContent>
          {/*<DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText>*/}
        </DialogContent>
        <DialogActions>
          <Button onClick={onHide} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              this.logout();
            }}
            color="primary"
            variant="contained"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // logout: data => dispatch(logout(data))
  };
};

export default connect(null, mapDispatchToProps)(LogoutImpl);



// WEBPACK FOOTER //
// ./src/components/Common/Model/Logout.jsx